import moment from 'moment'

export default function (datetime) {
  if (!datetime) {
    return null
  }

  return moment(datetime, moment.ISO_8601).format('YYYY-MM-DD HH:mm')
}



// WEBPACK FOOTER //
// ./src/components/Filters/DateWithMinutes.js